import { createFileRoute } from "@tanstack/react-router";
import { getAthletes, listAthleteFilters } from "api-client";
import { z } from "zod";

import { PAGE_SIZE as ATHLETES_DEFAULT_PAGE_SIZE } from "src/athlete/CoachAthleteList";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachAthletesPage } from "src/pages/CoachAthletesPage";

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  labels: z.array(z.string()).optional(),
  partnershipTypes: z
    .array(z.enum(["ONLINE", "IN_PERSON", "HYBRID"]))
    .optional(),
  tab: z.enum(["active", "archived"]).optional(),
  filterId: z.string().optional(),
  lastWorkoutDate: z.array(z.string()).optional(),
  products: z.array(z.string()).optional(),
});

export const Route = createFileRoute("/_auth/_coach/athletes/")({
  component: CoachAthletesPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async (ctx) => {
      const pageSize = deps.ps || ATHLETES_DEFAULT_PAGE_SIZE;
      const athleteFiltersEnabled =
        ctx.session?.entitlements.canAccessAthleteFilters === true;

      const [athletes, athleteFilters] = await Promise.all([
        getAthletes({
          query: {
            pageIndex: Number(deps.p) || 0,
            query: deps.q || "",
            pageSize,
            labelIds: deps.labels,
            partnershipTypes: deps.partnershipTypes,
            productIds: deps.products,
            status: deps.tab === "archived" ? "archived" : "active",
            filterId:
              athleteFiltersEnabled && deps.tab !== "archived"
                ? deps.filterId
                : undefined,
            lastWorkoutDate:
              athleteFiltersEnabled && deps.tab !== "archived"
                ? deps.lastWorkoutDate?.[0]
                : undefined,
          },
        }).then((res) => {
          return res.data.data;
        }),
        athleteFiltersEnabled
          ? listAthleteFilters().then((res) => {
              return res.data.data.filters;
            })
          : Promise.resolve([]),
      ]);

      return {
        data: {
          athletes,
          athleteFilters,
          pageSize,
        },
      };
    });
  },
});
